/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function PublishStatusInCollection({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#PublishStatusInCollection_svg__a)"><path d="M9 6.9a.6.6 0 0 0 0 1.2h2a.6.6 0 1 0 0-1.2H9ZM6.4 10a.6.6 0 0 1 .6-.6h6a.6.6 0 1 1 0 1.2H7a.6.6 0 0 1-.6-.6ZM9 11.9a.6.6 0 0 0 0 1.2h2a.6.6 0 1 0 0-1.2H9Z" /><path fillRule="evenodd" d="M.4 6a5.602 5.602 0 0 0 4.181 5.419 5.6 5.6 0 1 0 6.837-6.837A5.602 5.602 0 0 0 .4 6ZM6 1.6a4.4 4.4 0 0 0-1.6 8.5V10a5.6 5.6 0 0 1 5.7-5.6A4.402 4.402 0 0 0 6 1.6Zm4 4a4.4 4.4 0 1 0 0 8.8 4.4 4.4 0 0 0 0-8.8Z" clipRule="evenodd" /></g><defs><clipPath id="PublishStatusInCollection_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;